import * as React from "react";
import {Fragment} from "react";
import {
    ApplicationState,
    handleInvalidPasswordChange,
    UserPasswordStatus,
    UserStatus,
    UserStoreState
} from "../user/UserStore";
import {connect} from "react-redux";
import {UserAuthenticationService} from "../services/UserAuthenticationService";
import {getContainer} from "../ioc/IOCSetup";
import {UserActions} from "../user/UserActions";
import {LoadingSpinner} from "../util/LoadingSpinner";


interface State {
    username? : string;
    password? : string;
    status? : UserStatus;
    submitted? : boolean;
    loading? : boolean;
    repeatNewPassword?: string;
    newPassword?: string;
}

const mapStateToProps = (state : ApplicationState) : UserStoreState => {
    return state.user;
};

export class LoginForm extends React.Component<UserStoreState,State>{
    dashboardUserService : UserAuthenticationService;
    constructor(props : UserStoreState) {
        super(props);
        this.dashboardUserService = getContainer().getUserAuthenticationService();
        this.state = { loading : false};
    }

    componentDidMount(): void {
        new UserActions().getUserInfo(false);
        this.showLoginBG();

    }
    componentDidUpdate(prevProps: Readonly<UserStoreState>, prevState: Readonly<State>, snapshot?: any): void {
        if(prevProps.status !== this.props.status) {
            if(this.props.status !== UserStatus.LOGGED_IN) {
               this.showLoginBG();
            } else {
              this.hideLoginBG();
            }

        }
        if(prevProps.expandedMenu !== this.props.expandedMenu) {
            if(this.props.expandedMenu === true) {
                let bodyEl = document.getElementById("mainBody");
                if(bodyEl) {
                    bodyEl.classList.add("enlarged")
                    bodyEl.classList.add("sidebar-enable");
                }
            } else {
                let bodyEl = document.getElementById("mainBody");
                if(bodyEl) {
                    bodyEl.classList.remove("enlarged");
                    bodyEl.classList.remove("sidebar-enable");
                }
            }
        }
    }
    showLoginBG() {
        let bodyEl = document.getElementById("mainBody");
        if(bodyEl) {
            bodyEl.classList.add("authentication-bg")
            bodyEl.classList.add("authentication-bg-pattern");
        }
    }
    hideLoginBG() {
        let bodyEl = document.getElementById("mainBody");
        if(bodyEl) {
            bodyEl.classList.remove("authentication-bg")
            bodyEl.classList.remove("authentication-bg-pattern");
        }
    }

    onSubmit(e : any) {
        e.preventDefault();
        if(this.state.username != null && this.state.password != null) {
          new UserActions().login(this.state.username, this.state.password);
        }
    }
    changePasswordAndLogin(e : any) {
        e.preventDefault();
        if(this.state.username != null && this.state.password != null && this.state.newPassword != null) {
            if(this.state.newPassword !== this.state.repeatNewPassword) {
                handleInvalidPasswordChange();
            } else {
                new UserActions().changePasswordAndLogin(this.state.username, this.state.password, this.state.newPassword);
            }
        }
    }

    changeUsername(e : React.FormEvent) {
        var value : string = (e.target as any).value;
        this.setState({ username : value });
    }
    updateRepeatNewPassword(e : React.FormEvent) {
        var value : string = (e.target as any).value;
        this.setState({ repeatNewPassword : value });
    }
    updateNewPassword(e : React.FormEvent) {
        var value : string = (e.target as any).value;
        this.setState({ newPassword : value });
    }
    changePassword(e : React.FormEvent) {
        var value : string = (e.target as any).value;
        this.setState({ password : value });
    }


    getErrorMessage() {
        if(this.props.status === UserStatus.LOGIN_ERROR) {
            return <div className="alert alert-warning">Unable to login, please check your username/password</div>
        }
        return <div/>;
    }


    getLoginForm() {
        if(this.props.passwordStatus !== UserPasswordStatus.NONE) {
            return (
                <form className="m-t"  onSubmit={this.changePasswordAndLogin.bind(this)} style={{opacity : this.props.passwordStatus === UserPasswordStatus.IN_PROGRESS? 0.5 : 1}}>
                    <div className="alert alert-warning">
                        You are required to change your password
                    </div>
                    {this.props.passwordStatus === UserPasswordStatus.INVALID_PASSWORD_CHANGE && (
                        <div className={"alert alert-danger"}>Invalid password, make sure your new password follow the password requirements</div>
                    )}
                    <input type="text"  value="" style={{display:"none"}}/>
                    <input type="text" value="" style={{display:"none"}}/>
                    <input type="password" value="" style={{display:"none"}}/>
                    <div className="form-group mb-3">
                        <label>Password</label>
                        <input type="password" autoComplete="false" className="form-control" onChange={this.updateNewPassword.bind(this)} placeholder="New Password" required={true}/>
                        <span className={"help"}>
                            Password must be between 8-50 characters and at least one of the following: lowercase letter, uppercase letter and number
                        </span>
                    </div>
                    <div className="form-group mb-3">
                        <label>Repeat new password</label>
                        <input type="password" autoComplete="false"  className="form-control" onChange={this.updateRepeatNewPassword.bind(this)} placeholder="Repeat New Password" required={true}/>
                    </div>
                    <div className={"form-group mb-0 text-center"}>
                        <button type="submit" className="btn btn-primary btn-block">Change Password & Login</button>
                    </div>

                </form>
            )
        }

        if(this.state.loading === true) {
            return <LoadingSpinner/>;
        }
        return (
            <form className="m-t"  onSubmit={this.onSubmit.bind(this)} style={{opacity : this.props.status === UserStatus.IN_PROGRESS ? 0.5 : 1}}>
                {this.getErrorMessage()}
                <div className="form-group mb-3">
                    <label>E-mail</label>
                    <input type="text" id={"username"} className="form-control" required={true} onChange={this.changeUsername.bind(this)}/>
                </div>
                <div className="form-group mb-3">
                    <label>
                        Password
                    </label>
                    <input type="password" id="password"  className="form-control" onChange={this.changePassword.bind(this)} required={true}/>
                </div>
                <div className={"form-group mb-0 text-center"}>
                    <button type="submit" id={"loginButton"} className="btn btn-primary btn-block">
                        <span>LOGIN</span>
                    </button>
                </div>

            </form>
        );
    }
    render() {
        if(this.props.status === UserStatus.LOGGED_IN) {
            return <div/>;
        }

        return (

            <Fragment>
                <div className="account-pages mt-5 mb-5">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 col-lg-6 col-xl-5">
                                <div className="card bg-pattern">

                                    <div className="card-body p-4">

                                        <div className="text-center w-75 m-auto">
                                            <h3>NANO Admin</h3>
                                            <p className="text-muted mb-4 mt-3">Enter your email address and password to access admin panel.</p>
                                        </div>


                                        {this.getLoginForm()}

                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-12 text-center">
                                        <p> <a href="pages-recoverpw.html" className="text-white-50 ml-1">Forgot your password?</a></p>
                                        <p className="text-white-50">Don't have an account? <a href="pages-register.html" className="text-white ml-1"><b>Sign Up</b></a></p>
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>

                </div>

            </Fragment>
        );
    }
}

export default connect(mapStateToProps)(LoginForm);